import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../shared/components/base.component';
import { ResetPasswordService } from './reset-password.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserPreferencesService } from '../shared/service/user-preferences.service';
import { ApplicationConfig } from '../../config/application.config';
import { LoggerService } from '../shared/service/logger.service';
import { AuthorizationService } from '../shared/service/authorization.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    providers: [ResetPasswordService]
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

    public password: string;
    public confirmPassword: string;
    public isProccessing: boolean;
    public isPasswordCreationDone: boolean;
    public isPasswordCreationError: boolean;
    public logoUrl: string;
    public passwordResetCode: string;
    public username: string;
    public isLoading: boolean;

    constructor(private resetPasswordService: ResetPasswordService, private router: Router, private route: ActivatedRoute,
        private userPreferencesService: UserPreferencesService, public applicationConfig: ApplicationConfig,
        private loggerService: LoggerService, private authorizationService: AuthorizationService) {
        super();
    }

    ngOnInit() {
        this.password = '';
        this.confirmPassword = '';
        this.isPasswordCreationDone = false;
        this.isPasswordCreationError = false;
        this.isProccessing = false;
        this.isLoading = true;
        this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
        this.authorizationService.clearSession();
        this.route.params.subscribe(params => {
            this.passwordResetCode = params['passwordResetCode'];
            this.getUserByPasswordResetCode();
        });
    }

    public onInputFocus() {
        this.isPasswordCreationError = false;
    }

    public areBothPasswordEqual(): boolean {
        return this.password === this.confirmPassword;
    }

    public doesPasswordHaveTargetedLenght(): boolean {
        return this.password.length >= this.applicationConfig.MIN_PASSWORD_LENGTH;
    }

    public goToLoginPage() {
        this.router.navigate(['login'], { relativeTo: this.route.parent });
    }

    public onSubmit() {
        this.isPasswordCreationError = false;
        this.isProccessing = true;
        this.resetPasswordService.savePassword(this.passwordResetCode, this.password).subscribe(
            () => this.isPasswordCreationDone = true,
            () => {
                this.isProccessing = false;
                this.isPasswordCreationError = true;
            },
            () => this.isProccessing = false
        );
    }

    private getUserByPasswordResetCode() {
        this.resetPasswordService.getUserByPasswordResetCode(this.passwordResetCode).subscribe(
            user => {
                this.isLoading = false;
                this.username = user.username;
            }
        );
    }
}
